import React from "react";
import { View, StyleSheet, Image } from "react-native";
import NtMarketingSectionContainer from "../general/NtMarketingSectionContainer";
import NtSectionTitle from "../general/NtSectionTitle";
import NtSectionBullet from "../general/NtSectionBullet";
import { useMobile } from "../../../hooks/useMobile";
import NtText from "../../../components/NtText";

function NtDevopskubernetesSection({}) {
  const isMobile = useMobile();

  return (
    <NtMarketingSectionContainer
      style={styles.container}
      backgroundImage={require("../../../assets/images/marketing/b743f2b253db3a1230d1ccbea84eba254b6390d2.jpg")}
    >
      <View
        style={{
          flex: 1,
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        {/* left */}
        <View
          style={{
            flex: isMobile ? 0.5 : 1,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Image
            style={[
              {
                width: 350,
                height: 350,
                resizeMode: "contain",
              },
            ]}
            source={require("../../../assets/images/marketing/devops-kube-logo.png")}
          />
        </View>

        {/* right */}
        <View style={{ flex: 1, justifyContent: "center" }}>
          <NtSectionTitle style={{ textAlign: "left", fontWeight: "300" }}>
            DEPLOY YOUR{" "}
            <NtText style={{ fontWeight: "900" }}>DOCKER CONTAINERS</NtText>{" "}
            WITH{" "}
            <NtText style={{ fontWeight: "900" }}>
              KUBERNETES ORCHESTRATION
            </NtText>
          </NtSectionTitle>

          <NtSectionBullet containerStyle={{ marginTop: 30 }}>
            New cloud-native DevOps tools are emerging to transformation of IT
            teams in the enterprise.
          </NtSectionBullet>

          <NtSectionBullet containerStyle={{ marginTop: 30 }}>
            Provide high availability, and zero downtime updates to your
            containerized applications.
          </NtSectionBullet>

          <NtSectionBullet containerStyle={{ marginTop: 30 }}>
            Minimize IT overhead and management costs.
          </NtSectionBullet>
        </View>
      </View>
    </NtMarketingSectionContainer>
  );
}

const styles = StyleSheet.create({
  container: { height: 600 },
});

export default NtDevopskubernetesSection;
